import { create } from 'apisauce'

/*
const api = create({
  baseURL: process.env.REACT_APP_STAGE_OIKOS_API_URL,
})
*/
const api = create({
  baseURL: process.env.REACT_APP_OIKOS_API_URL,
})



api.addResponseTransform(response => {
  if (!response.ok) throw response
})

export default api
